module.exports = __webpack_public_path__ + "static/media/DSC_0260.b617c5df.jpg";